import i18n from '@/plugins/i18n'

/**
 * Перевести строку, если это ключ перевода, иначе вернуть как есть.
 *
 * Общие компоненты (TheDialog, TheDrawer, DataCol, TheFormItem, TheTableColumn,
 * TheCheckbox) сами переводят заголовок/подпись, а вызывающие код местами передаёт им уже
 * переведённый текст или пользовательские данные (ФИО, название поля из справочника).
 * Повторный t() на таком тексте видимо ничего не менял — возвращал строку как есть, — но
 * сыпал в консоль «Not found '…' key». Результат для пользователя тот же: резервной локали
 * в проекте нет, и t() на отсутствующем ключе тоже возвращает сам ключ.
 */
export default function translateIfKey(value) {
  if (!value) {
    return ''
  }
  return i18n.global.te(value) ? i18n.global.t(value) : value
}
